import { render, staticRenderFns } from "./commonStep.vue?vue&type=template&id=045c1d78&scoped=true"
import script from "./commonStep.vue?vue&type=script&lang=js"
export * from "./commonStep.vue?vue&type=script&lang=js"
import style0 from "./commonStep.vue?vue&type=style&index=0&id=045c1d78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.4_vue-template-compiler@2.7.14_webpack@5.83.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045c1d78",
  null
  
)

export default component.exports